export default "__VITE_ASSET__BEd3c7eZ__"